import { default as axios, AxiosRequestConfig } from 'axios';

import { PATH_TO_AUTH_API } from '@shared/constants';

/**
 * Command to change the password of a user
 * @export
 * @interface ChangePasswordCommand
 */
export interface ChangePasswordCommand {
  /**
   * The current password
   * @type {string}
   * @memberof ChangePasswordCommand
   */
  currentPassword: string;
  /**
   * The new password to be set
   * @type {string}
   * @memberof ChangePasswordCommand
   */
  newPassword: string;
  languageAbbreviation: string;
}

/**
 * Command to initiate password reset procedure
 * @export
 * @interface ForgotPasswordCommand
 */
export interface ForgotPasswordCommand {
  /**
   * The email address, for which the password reset procedure should be
   * initiated.
   * @type {string}
   * @memberof ForgotPasswordCommand
   */
  email: string;
  languageAbbreviation: string;
}

/**
 * Command to reset a password for a user
 * @export
 * @interface ResetPasswordCommand
 */
export interface ResetPasswordCommand {
  /**
   * The token to verify that this request has been initiated by the real user
   * @type {string}
   * @memberof ResetPasswordCommand
   */
  token: string;
  /**
   * The email address of this user
   * @type {string}
   * @memberof ResetPasswordCommand
   */
  email: string;
  /**
   * The new password to be applied
   * @type {string}
   * @memberof ResetPasswordCommand
   */
  password: string;
  /*
   * Flag indicating that user confirmed agreement to terms of use.
   * */
  areTermsOfUseSigned: boolean;
  languageAbbreviation: string;
}

const defaultOpts: AxiosRequestConfig = {
  baseURL: PATH_TO_AUTH_API,
};

export const IdentityApi = {
  changeYourOwnPassword: (changePasswordCommand?: ChangePasswordCommand, options?: AxiosRequestConfig) => {
    return axios.put('/User/password', changePasswordCommand, { ...defaultOpts, ...options });
  },
  forgotPassword: (forgotPasswordCommand?: ForgotPasswordCommand, options?: AxiosRequestConfig) => {
    return axios.post('/User/forgotPassword', forgotPasswordCommand, { ...defaultOpts, ...options });
  },
  resetPassword: (data: ResetPasswordCommand, options?: AxiosRequestConfig): Promise<void> => {
    return axios.post('/User/resetPassword', data, { ...defaultOpts, ...options });
  },
};
